@if (genderUuid(); as genderUuid) {
  @if (genderDict$ | async; as genderDict) {
    @if (genderDict[genderUuid]; as gender) {
      <span>
        {{ genderTranslations[gender.gender_key] || 'common.unknown' | translate }}
      </span>
    } @else {
      <span>
        {{ 'common.unknown' | translate }}
      </span>
    }
  }
}
